function extractDigits(str) {
    return str.replace(/\D/g, '');
}

export default function injectLDJson(obj, openTimeList, categoryList) {

    
    // 如果是ssg 直接return
    if(window && window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isSsg) {

        return
    }

    const existing = document.querySelector('script[type="application/ld+json"]');
    if (existing) {
        existing.remove();
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";

    let { origin, pathname } = new URL(location.href);
    let url = origin + pathname
    let cuisineStr = obj.cuisines && obj.cuisines.split(",");
    let menuList = [];
    categoryList.forEach(ele => {
        menuList.push({
            "@type": "MenuSection",
            "name": ele.categoryName.split(' ').join('_'),
            "url": `${url}#${ele.categoryName}`
        })
    });
    const weekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ];
    openTimeList.sort((a,b)=>a.weekday-b.weekday)
    let openTimeObjList = openTimeList.map((x,ind) => {
        return {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: weekDays[ind],
            opens: x.startTime1 || x.startTime2,
            closes: x.endTime1 || x.endTime2,
        };
    });

    const data = {
        "@context": "https://schema.org",
        "@type": "Restaurant",
        "name": obj.restaurantName,
        "url": url,
        "logo": obj.merchantLogo,
        "image": obj.merchantBackground,
        "paymentAccepted": "Credit Card, Cash",
        "acceptsReservations": obj.merchantTableBooking == 1,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": obj.merchantAddr.replace(obj.postCode, ""),
            "postalCode": obj.postCode,
            "addressLocality": "",
            "addressRegion": "",
            "addressCountry": obj.currencySign == "￡" ? "GB" : "IRE",
        },
        "telephone":
            (obj.currencySign == "￡" ? "+44 " : "+353 ") + extractDigits(obj.restaurantPhone),
        "latitude": obj.latitude,
        "longitude": obj.lontitude,
        "openingHoursSpecification": openTimeObjList,
        "servesCuisine": cuisineStr,
        "menu": url,
        "priceRange": "££",
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": obj.tasteRating ? obj.tasteRating : 5,
            "reviewCount": obj.reviewCount ? obj.reviewCount : 1,
        },
        "hasMenu": {
            "@type": "Menu",
            "name":  obj.restaurantName +  " Menu",
            "hasMenuSection": menuList
        }
    };

    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    console.log('seo标签插入完毕')


    const head = document.head;
    const tags = [
        { tag: 'meta', attrs: { name: 'robots', content: 'index, follow' } },
        { tag: 'meta', attrs: { property: 'og:locale', content: 'en_GB' } },
        { tag: 'meta', attrs: { property: 'og:type', content: 'restaurant' } },
        { tag: 'meta', attrs: { property: 'og:title', content: obj.seoMenuMeta || obj.restaurantName } },
        { tag: 'meta', attrs: { property: 'og:description', content: obj.seoMenuMeta || obj.restaurantName  } },
        { tag: 'meta', attrs: { property: 'og:url', content: url } },
        { tag: 'meta', attrs: { property: 'og:site_name', content: 'All Eat' } },
        { tag: 'meta', attrs: { property: 'og:image', content: obj.merchantLogo } },
        { tag: 'meta', attrs: { name: 'twitter:card', content: 'summary_large_image' } },
        { tag: 'meta', attrs: { name: 'twitter:description', content: obj.seoMenuMeta || obj.restaurantName  } },
        { tag: 'meta', attrs: { name: 'twitter:title', content: obj.seoMenuMeta || obj.restaurantName } },
        { tag: 'meta', attrs: { name: 'twitter:image', content: obj.merchantLogo } },
        { tag: 'meta', attrs: { name: 'twitter:site', content: '@alleat_app' } },
        { tag: 'meta', attrs: { name: 'twitter:creator', content: '@alleat_app' } },
        { tag: 'link', attrs: { rel: 'alternate', hreflang: 'en-gb', href: url } }
    ];

    tags.forEach(({ tag, attrs }) => {
        // 构建唯一属性键名（优先使用 name、property、rel 区分）
        const keyAttr = attrs.name || attrs.property || attrs.rel;
        const keyAttrName = attrs.name ? 'name' : (attrs.property ? 'property' : 'rel');

        // 避免重复添加
        let targetMeta = document.head.querySelector(`${tag}[${keyAttrName}="${keyAttr}"]`);
        if (targetMeta) {
            targetMeta.remove();
        }

        const el = document.createElement(tag);
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        head.appendChild(el);
    });

  console.log('meta标签 添加完毕')

}



